import { createRoute, redirect } from "@tanstack/react-router";

import { isMeaningfulGigsRole } from "../../utils/auth";
import { askPunttRoute } from "../ask-puntt/route";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const indexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "/",
  beforeLoad() {
    throw redirect({
      to: isMeaningfulGigsRole() ? askPunttRoute.to : ticketsRoute.to,
    });
  },
});
